/**
 * Environmental Equipment Guidance - Simple Direct Pattern
 * Uses requirement ID mapping from environmental.simple.js
 */

import { ENVIRONMENTAL_GUIDANCE } from "./environmental.simple";

/**
 * Get Environmental Equipment Guidance
 * @param {string} itemId - Equipment requirement ID
 * @returns {Object|null} Guidance object or null
 */
export function getEnvironmentalGuidance(itemId) {
  // Early return - no debug logging for missing guidance
  return ENVIRONMENTAL_GUIDANCE[itemId] || null;
}